export const FLOATING_PANE_INVITE_FRIENDS_PANE = 'invite_friends_pane'
